import { render } from '@wordpress/element';
import App from './App/FrontendApp';
import { SettingsProvider } from './App/SettingsContext';

document.addEventListener('DOMContentLoaded', () => {
  	const root = document.getElementById('mctqfw_quote_sidebar');

  	if (root) {
	    render(
	      	<SettingsProvider>
	        	<App />
	      	</SettingsProvider>,
	     	root
	    );
  	}
});